module.exports = __webpack_public_path__ + "img/jcb.32c107df.svg";